<div [@backgroundFade]="pageState.path === 'sport' ? 'in' : 'out'" class="wrapper-sport"></div>
<div [@backgroundFade]="pageState.path === 'developer' ? 'in' : 'out'" class="wrapper-developer"></div>
<div [@backgroundFade]="pageState.path === 'explorer' ? 'in' : 'out'" class="wrapper-explorer"></div>

<div class="front" (swipeleft)="rotateLeft()" (swiperight)="rotateRight()">
  <div class="dim-top"></div>
  <button
    [ngClass]="{
      'rotate-left': true,
      'bg-explorer-hover': pageState.path === 'explorer',
      'bg-developer-hover': pageState.path === 'developer',
      'bg-sport-hover': pageState.path === 'sport'
    }"
    (click)="rotateLeft()"
  >
    &#10094;
  </button>
  <button
    [ngClass]="{
      'rotate-right': true,
      'bg-explorer-hover': pageState.path === 'explorer',
      'bg-developer-hover': pageState.path === 'developer',
      'bg-sport-hover': pageState.path === 'sport'
    }"
    (click)="rotateRight()"
  >
    &#10095;
  </button>

  <div class="carousel">
    <div [@rot]="pageState.path" class="pagination">
      <div *ngFor="let page of pages">
        <span
          class="{{ page.pagItemClass }}"
          [ngClass]="{
            'bg-explorer': pageState.path === 'explorer',
            'bg-developer': pageState.path === 'developer',
            'bg-sport': pageState.path === 'sport'
          }"
          >{{ page.name }}</span
        >
      </div>
    </div>
  </div>

  <div class="front-name">SAMI VALKONEN</div>
  <div class="front-desc" [innerHtml]="pageState.pageIntroHtml"></div>

  <!-- <div class="scroll">
    Scroll Down
    <div class="scroll-arrow"><i class="fas fa-arrow-down"></i></div>
  </div> -->
</div>

<router-outlet></router-outlet>


<!-- <div class="prof">
<div class="prof-wrapper">
<div *ngFor="let prof of profs" class="prof-clmn">
<h2>{{prof.header}}</h2>
<p *ngFor="let para of prof.paras">{{para}}</p>
<a routerLink="/interests">My Projects</a>
<img src={{prof.imgSrc}} alt={{prof.header}}>
</div>
</div>
</div>

<div class="intrests-bg">
<div class="intrests-wrapper">
<div *ngFor="let interest of interests" class="interest-clmn"
(mouseenter)="intHoverIn(interest)" (mouseleave)="intHoverOut(interest)"
[class.interest-hover]="interest === hoveredInterest">
<div class="img-content" [class.hovered]="interest === hoveredInterest">
<img src="{{interest.imgVisible}}" alt="{{interest.header}}">
</div>
<div class="text-content">
<h1>{{interest.header}}</h1>
<p *ngFor="let para of interest.paras">{{para}}</p>
<a routerLink="/{{interest.routerLink}}">View More</a>
</div>
</div>
</div>
</div> -->
